require('../../modules/es6.math.log2');
module.exports = require('../../modules/_core').Math.log2;



//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/~/core-js/library/fn/math/log2.js
// module id = 1453
// module chunks = 0